import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 登録方法 */
enum RegistrationMethod {
  singleReg = '1',
  dataImport = '2',
  multiReg = '3',
  bulkInstr = '4',
  incDecCancel = '5',
}

const nameConfig = {
  singleReg: new Map([[Locale.ja, '1件登録']]),
  dataImport: new Map([[Locale.ja, 'データ取込']]),
  multiReg: new Map([[Locale.ja, '複数選択登録']]),
  bulkInstr: new Map([[Locale.ja, '一括指示']]),
  incDecCancel: new Map([[Locale.ja, '増減取消']]),
};

const toEnum = rawValueToEnum(RegistrationMethod, RegistrationMethod.singleReg);
const toDisplay = enumToName(RegistrationMethod, nameConfig);
const toDisplayWithPrefix = enumToName(RegistrationMethod, nameConfig, { prefix: true });

export const registrationMethod = {
  enum: RegistrationMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { RegistrationMethod };
